export default __webpack_public_path__ + "1b02b335e7eede04fd7cf82de84f4261.png";